import { ReactNode } from 'react';
import './tabs.css';

export interface TabHeaderItemProps {
  id: string;
  text: string;
}

interface TabHeaderProps {
  items: TabHeaderItemProps[];
  activeId: string;
  onTabClick: (id: string) => void;
}

interface TabBodyProps {
  tabId: string;
  activeId: string;
  children: ReactNode;
}

interface TabBodyEmptyProps {
  title: string;
  text: string;
  icon: string;
}

export const TabHeader = ({ items, activeId, onTabClick }: TabHeaderProps) => {
  return (
    <div className='tab-header'>
      {items.map((item) => (
        <button
          key={item.id}
          type='button'
          role='tab'
          className={`tab-button ${item.id === activeId ? 'active' : ''}`}
          onClick={() => onTabClick(item.id)}
        >
          {item.text}
        </button>
      ))}
    </div>
  );
};

export const TabBody = ({ tabId, activeId, children }: TabBodyProps) => {
  return (
    <div className={`tab-body ${tabId !== activeId ? 'hidden' : ''}`}>
      {children}
    </div>
  );
};

export const TabBodyEmpty = ({ title, text, icon }: TabBodyEmptyProps) => (
  <div className='tab-body-empty'>
    <img src={icon} alt='Empty Icon' className='tab-body-empty-icon' />
    <h3 className='tab-body-empty-title'>{title}</h3>
    <p className='tab-body-empty-text'>{text}</p>
  </div>
);
